import { render, staticRenderFns } from "./projectBoard.vue?vue&type=template&id=05ef433d&scoped=true"
import script from "./projectBoard.vue?vue&type=script&lang=js"
export * from "./projectBoard.vue?vue&type=script&lang=js"
import style0 from "./projectBoard.vue?vue&type=style&index=0&id=05ef433d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ef433d",
  null
  
)

export default component.exports